import { api, currentCreche } from '../api'

const DocumentRepository = {
    index (query = {}) {
        return api().$get(`/${currentCreche().uuid}/documents`, query)
    },

    dataToExcel (data, filename) {
        return api().$post(`/${currentCreche().uuid}/data-export-excel`, { data, filename }, { download: true })
    },

    create (payload) {
        return api().$post(`/${currentCreche().uuid}/documents`, payload)
    },

    replace (payload) {
        return api().$post(`/${currentCreche().uuid}/documents/unique`, payload)
    },

    update (documentUuid, payload) {
        return api().$patch(`/${currentCreche().uuid}/documents/${documentUuid}`, payload)
    },

    delete (documentUuid) {
        return api().$delete(`/${currentCreche().uuid}/documents/${documentUuid}`)
    },

    get (document) {
        return api().$get(`/${currentCreche().uuid}/documents/${document}`)
    },

    dape (query) {
        return api().$get(`/${currentCreche().uuid}/documents/one/dape`, query)
    },

    retrocession (payload) {
        return api().$get(`/${currentCreche().uuid}/documents/one/retrocession`, payload)
    },

    vaccinationCalendar (payload) {
        return api().$get(`/${currentCreche().uuid}/documents/one/vaccination-calendar`, payload, { download: true })
    },

    c220b (payload) {
        return api().$get(`/${currentCreche().uuid}/documents/sae/c220b`, payload, { download: true })
    },

    saeDape (payload) {
        return api().$get(`/${currentCreche().uuid}/documents/sae/annex-activity-report`, payload, { download: true })
    },

    saeMutuelle (payload) {
        return api().$get(`/${currentCreche().uuid}/documents/sae/mutuelle`, payload, { download: true })
    },

    aesDape (payload) {
        return api().$get(`/${currentCreche().uuid}/documents/aes/activity-report`, payload, { download: true })
    },

    aesActivityReport (payload) {
        return api().$get(`/${currentCreche().uuid}/documents/aes/activity-report-month-excel`, payload, { download: true })
    },

    aesQuarterActivityReport (payload) {
        return api().$get(`/${currentCreche().uuid}/documents/aes/activity-report-quarter-excel`, payload, { download: true })
    },

    stageMutuelles (payload) {
        return api().$post(`/${currentCreche().uuid}/documents/stage/mutuelles`, payload, { download: true })
    },

    occupationReport (payload) {
        return api().$post(`/${currentCreche().uuid}/reports/occupation`, payload)
    },

    occupationReportMonthly (query) {
        return api().$get(`/${currentCreche().uuid}/reports/occupation/monthly`, query)
    },

    babyContactOverview (registrationUuid, crecheUuid = null) {
        return api().$get(`/${crecheUuid || currentCreche().uuid}/documents/registration/${registrationUuid}/baby-contact-overview`, null, { download: true })
    },

    babyMedicalOverview (babyUuid) {
        return api().$get(`/${currentCreche().uuid}/documents/baby/${babyUuid}/medical-overview`, null, { download: true })
    },

    registrationONEDocument (registrationUuid) {
        return api().$get(`/${currentCreche().uuid}/registrations/${registrationUuid}/registration-one-document`, null, { download: true })
    },
    getRegistrationsForONEDocumentBasic (params) {
        return api().$get(`/${currentCreche().uuid}/registration-one-document/basic-registrations`, { params })
    },
    getRegistrationsForONEDocumentMajorated (params) {
        return api().$get(`/${currentCreche().uuid}/registration-one-document/majorated-registrations`, { params })
    },
    registrationONEDocumentMultiple (payload) {
        return api().$post(`/${currentCreche().uuid}/generate/registration-one-documents`, payload)
    },

    registrationRemunerationDeclarationDocument (registrationUuid) {
        return api().$post(`/${currentCreche().uuid}/registrations/${registrationUuid}/remuneration-declaration-document`, null, { download: true })
    },

    registrationFiscalDocumentMassive (payload) {
        return api().$post(`/${currentCreche().uuid}/generate/fiscal-documents`, payload, { download: true })
    },

    fill (mediaUuid, payload, crecheUuid = null) {
        return api().$post(`/${crecheUuid || currentCreche().uuid}/documents/fill/${mediaUuid}`, payload, { download: true })
    },

    fillContract (payload, document = 'contract', crecheUuid = null) {
        return api().$post(`/${crecheUuid || currentCreche().uuid}/documents/fill-${document}`, payload, { download: true })
    },

    fillContracts (payload, document = 'contract', crecheUuid = null) {
        return api().$post(`/${crecheUuid || currentCreche().uuid}/documents/fill-${document}/multiple`, payload, { download: true })
    }
}

export default DocumentRepository
